import { useEffect, useState } from 'react';
import CollectivePreviewModal from '../components/collectivePreviewModal';
import { CollectiveActionType } from '../components/types/collectiveActionType';
import CollectiveIcons from '../components/collectiveIcons';
import { CollectiveSelectFieldProps } from './types/collectiveSelectFieldProps';
import CollectiveLabelChip from '../components/collectiveLabelChip';
import { collectiveViewCallback } from '../../../../helpers/collective/preview';

const CollectiveSelectField = (props: CollectiveSelectFieldProps) => {
    const [preview, setPreview] = useState<boolean>(false);

    useEffect(() => {
        if (props.actions === undefined) {
            return;
        } else {
            if (hasValue(props.value)) {
                if (props.actions[props.keyName] === CollectiveActionType.Delete) {
                    changeAction(null);
                }
            } else {
                if (props.actions[props.keyName] !== CollectiveActionType.Delete) {
                    changeAction(null);
                }
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.value])

    const onCardDelete = (ids: number[]) => {
        if (ids.length > 0 && props.onDelete !== undefined) {
            props.onDelete(ids);
        }
        setPreview(false);
    }

    const onPreviewClick = (show: boolean) => {
        setPreview(show);
    }

    const changeAction = (actionType: CollectiveActionType | null) => {
        if (props.setActions !== undefined) {
            props.setActions(props.keyName, actionType);
        }
    }

    const hasValue = (value: any) => {
        if (props.single) {
            return value !== null && value !== undefined && value !== '';
        } else {
            return value !== null && value !== undefined && value.length > 0;
        }
    }

    return (<div className='collective-input-container'>
        <div className="collective-input">
            {props.children}
            {props.isAuto !== undefined && <CollectiveLabelChip isAuto={props.isAuto} labelClass={props.labelClass} />}
        </div>
        <CollectiveIcons top={props.top}
            hasValue={hasValue(props.value)}
            fillCount={collectiveViewCallback(props.forms, props.keyName, true)}
            actionType={props.actions !== undefined ? props.actions[props.keyName] : null}
            onActionChange={(actionType: CollectiveActionType | null) => { changeAction(actionType) }}
            disableAdd={props.preventAdd === undefined ? props.single : props.preventAdd}
            disableOverwrite={props.preventOverwrite}
            disabledDelete={props.preventDelete}
            onPreview={onPreviewClick} />
        {preview && <CollectivePreviewModal
            title={props.title}
            data={collectiveViewCallback(props.forms, props.keyName, false, props.dic, props.dics)}
            onConfirm={onCardDelete} />}
    </div>)
}

export default CollectiveSelectField;